import '@react-pdf-viewer/core/lib/styles/index.css';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton, Stack, styled } from '@mui/material';

export const ModalContainer = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  width: '90%',
  height: '90%',
  alignItems: 'flex-start',
  backgroundColor: 'white',
  borderRadius: '1.5rem',
  boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  overflow: 'hidden',
}));

export const LeftSideContainer = styled(Box)(() => ({
  display: 'flex',
  padding: '1.25rem 0',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: '1 0 0',
  alignSelf: 'stretch',
  background: '#F7F8FC',
}));

export const InnerContainer = styled(Box)(() => ({
  display: 'flex',
  padding: '0 0.75rem',
  justifyContent: 'center',
  alignItems: 'center',
  flex: '1 0 0',
  alignSelf: 'stretch',
}));

export const CarouselContainer = styled(Box)(() => ({
  flex: '1 0 0',
  alignSelf: 'stretch',
  borderRadius: '1rem',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const NavigationButton = styled(IconButton)(() => ({
  display: 'flex',
  width: '2.75rem',
  height: '2.75rem',
  padding: '0.25rem',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '2.6875rem',
  background: 'var(--Background-1, #FEFEFE)',
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.14)',
}));

export const LeftButton = styled(NavigationButton)(() => ({
  marginRight: '0.75rem',
  '&:hover': {
    transform: 'scale(1.1)',
    transition: 'transform 0.2s ease-in-out',
    background: 'var(--Background-1, #FEFEFE)',
  },
}));

export const ImageBoxContainer = styled(Box)(() => ({
  flex: '1 0 0',
  height: '100%',
  borderRadius: '1rem',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: '#F7F8FC',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const PdfContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  backgroundColor: '#F7F8FC',
  overflow: 'hidden',

  '--rpv-core__page-layer-box-shadow': 'none',

  '& .rpv-core__viewer': {
    height: '100%',
    width: '100%',
    overflowY: 'auto',
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: 'transparent !important',
  },

  '& .rpv-core__page-layer': {
    boxShadow: 'none !important',
    border: 'none !important',
  },
}));

export const ImageLayer = styled(Box)<{ imageUrl: string }>(({ imageUrl }) => ({
  width: '100%',
  height: '100%',
  background: `url(${imageUrl}) center center / cover no-repeat`,
  transformOrigin: 'center center',
  transition: 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
}));

export const TitleOverlay = styled(Box)(() => ({
  display: 'inline-flex',
  gap: '0.625rem',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: '0.4rem',
  left: '0.4rem',
  height: '2.25rem',
  backgroundColor: 'rgba(255,255,255, 0.70)',
  borderRadius: '0.75rem',
  boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
  padding: '0 0.8125rem',
  backdropFilter: 'blur(2px)',
  maxWidth: 'calc(100% - 2.5rem)',
  minWidth: '8rem',
}));

export const ControlsOverlay = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'absolute',
  left: '50%',
  bottom: '0.75rem',
  transform: 'translateX(-50%)',
  width: '17rem',
  height: '3.375rem',
  borderRadius: '3.125rem',
  border: '1px solid rgba(255, 255, 255, 0.30)',
  backgroundColor: 'rgba(255, 255, 255, 0.80)',
  boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
  backdropFilter: 'blur(2px)',
  paddingLeft: '1.2rem',
  paddingRight: '1.2rem',
}));

export const RightActionsColumn = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  marginLeft: '0.75rem',
}));

export const ControlsOverlayPdfImage = styled(Stack)(() => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.625rem',
  position: 'absolute',
  top: '100%',
  marginTop: '6rem',
  width: '2.75rem',
  height: 'auto',
  borderRadius: '3.125rem',
  border: '1px solid rgba(255, 255, 255, 0.30)',
  backgroundColor: '#FEFEFE',
  boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
  backdropFilter: 'blur(2px)',
  padding: '1rem 0',
  zIndex: 10,
}));

export const RightButton = styled(NavigationButton)(() => ({
  '&:hover': {
    transform: 'scale(1.1)',
    transition: 'transform 0.2s ease-in-out',
    background: 'var(--Background-1, #FEFEFE)',
  },
}));

export const RightSideContainer = styled(Box)(() => ({
  display: 'flex',
  padding: '1.125rem 0.5rem 0 0.5rem',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '1.5rem',
  alignSelf: 'stretch',
  backgroundColor: 'white',
  width: '360px',
  borderLeft: '1px solid #E5E7EB',
  position: 'relative',
  boxShadow: '-5px 0 15px -5px rgba(0, 0, 0, 0.1)',
  zIndex: 10,
}));

export const SidebarHeader = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  flexShrink: 0,
}));

export const TabsContainer = styled(Box)(() => ({
  minWidth: '14rem',
  backgroundColor: '#F5F5F7',
  padding: '0.25rem',
  borderRadius: '0.625rem',
  display: 'inline-flex',
  gap: '0.5rem',
  boxShadow: '0 1px 1.9px 1px rgba(0, 0, 0, 0.05) inset',
}));

export const TabButton = styled('button')<{ active: boolean }>(({ active }) => ({
  color: active ? '#111827' : '#807D93',
  border: 'none',
  cursor: 'pointer',
  padding: '0.375rem 0.75rem',
  fontSize: '0.75rem',
  fontWeight: active ? 550 : 450,
  fontFamily: 'Neue Frutiger World',
  borderRadius: '0.375rem',
  backgroundColor: active ? '#FFFFFF' : 'transparent',
  boxShadow: active ? '0 1px 2px 1px rgba(0, 0, 0, 0.10)' : 'none',
  transition: 'all 0.2s ease',
  flex: 1,
}));

export const CloseButtonContainer = styled(Box)(() => ({
  alignSelf: 'flex-end',
  marginRight: '0.5rem',
  width: '2.5rem',
  height: '2.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '2097150rem',
  backgroundColor: 'rgba(255, 255, 255, 0.50)',
  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.20), 0 8px 10px -6px rgba(0, 0, 0, 0.10)',
  transition: 'all 0.1s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.80)',
    '& .MuiButtonBase-root': {
      transform: 'rotate(90deg)',
    },
  },
}));

export const CloseIconButton = styled(IconButton)(() => ({
  width: '100%',
  height: '100%',
  padding: 0,
  transition: 'all 0.1s ease',
  borderRadius: 'inherit',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent',
    transform: 'rotate(90deg)',
  },
}));

export const ErrorBanner = styled(Box)(() => ({
  marginTop: '1rem',
  padding: '0.5rem',
  backgroundColor: '#FEF2F2',
  border: '1px solid #FECACA',
  borderRadius: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
}));

export const UploadContainer = styled(Box)(() => ({
  alignSelf: 'flex-end',
  flexShrink: 0,
}));

export const StyledChevronLeft = styled(ChevronLeftIcon)(() => ({
  display: 'flex',
  width: '3.5rem',
  height: '3.5rem',
  padding: '0.625rem 0.6875rem 0.625rem 0.5625rem',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  color: '#504E5A',
}));

export const StyledChevronRight = styled(ChevronRightIcon)(() => ({
  display: 'flex',
  width: '3.5rem',
  height: '3.5rem',
  padding: '0.625rem 0.6875rem 0.625rem 0.5625rem',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  color: '#504E5A',
}));

export const FileListContainer = styled(Box)(() => ({
  width: '100%',
  flex: '1 1 auto',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  marginBottom: '1.2rem',
}));
